import { ExtendedAttributeOption } from 'app/library/extended-attribute-options/models/extended-attribute-option';
import { ExtendedAttributeCategoryEnum } from '../enums/extended-attribute-category.enum';
import { ExtendedAttributeType } from '../enums/extended-attribute-type.enum';
import { IExtendedAttributeQuery } from '../interfaces/extended-attribute.query.interface';

export class ExtendedAttribute {
    id: string;
    name: string;
    sort: number;
    type: ExtendedAttributeType;
    visible: boolean;
    editable: boolean;
    sharedByDefault: boolean;
    optionsEnabled: boolean;
    translationKey: string;
    'translation_en-GB': string;
    'translation_de-DE': string;
    'translation_fr-FR': string;
    'translation_it-CH': string;
    options: ExtendedAttributeOption[];
    missingTranslation: boolean;
    category: ExtendedAttributeCategoryEnum;
    mandatory?: boolean;
    enabledFor: {
        course: true;
        program: true;
        eLearning: true;
    };

    isOptionsMissingTranslation: boolean;

    constructor(query: IExtendedAttributeQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.sort = query.sort;
            this.type = query.type;
            this.visible = query.visible;
            this.editable = query.editable;
            this.sharedByDefault = query.shared_by_default;
            this.optionsEnabled = query.options_enabled;
            this.options = query.options ? query.options.map((option) => new ExtendedAttributeOption(option)) : [];
            this.translationKey = query.translation_key;
            if (query.translations) {
                if (query.translations['translation_en-GB']) {
                    this['translation_en-GB'] = query.translations['translation_en-GB'];
                }
                if (query.translations['translation_de-DE']) {
                    this['translation_de-DE'] = query.translations['translation_de-DE'];
                }
                if (query.translations['translation_fr-FR']) {
                    this['translation_fr-FR'] = query.translations['translation_fr-FR'];
                }
                if (query.translations['translation_it-CH']) {
                    this['translation_it-CH'] = query.translations['translation_it-CH'];
                }
            }
            this.missingTranslation = query.missing_translation;
            this.category = query.category;
            this.mandatory = query.mandatory;
            if (query.enabled_for) {
                this.enabledFor = {
                    course: query.enabled_for.course,
                    program: query.enabled_for.program,
                    eLearning: query.enabled_for.e_learning,
                };
            }
        }
    }
}
